import React, { forwardRef } from 'react'
import { NavToggleStyle } from './styles'

type ToggleProps = {
  open: boolean
  setOpen: React.Dispatch<React.SetStateAction<boolean>>
}

export const NavToggle = forwardRef<HTMLButtonElement, ToggleProps>(({ open, setOpen }, ref) => {
  return (
    <NavToggleStyle
      ref={ref}
      open={open}
      onClick={() => setOpen(prev => !prev)}
      aria-label={open ? 'Close navigation menu' : 'Open navigation menu'}
      aria-expanded={open}
      aria-controls="mobile-nav-panel"
    >
      <span />
      <span />
      <span />
    </NavToggleStyle>
  )
})

NavToggle.displayName = 'NavToggle'
